import React from "react";
import {
  MessagesSquare,
  ClipboardList,
  StickyNote,
  Info,
  LucideIcon,
  Plus,
} from "lucide-react";

type EmptyStateType = "activities" | "tasks" | "notes" | "leads" | "info";

interface EmptyStateConfig {
  icon: LucideIcon;
  message: string;
}

interface EmptyStateProps {
  type: EmptyStateType;
  actionLabel?: string;
  onAction?: () => void;
}

const config: Record<EmptyStateType, EmptyStateConfig> = {
  activities: {
    icon: MessagesSquare,
    message: "No activities yet",
  },
  tasks: {
    icon: ClipboardList,
    message: "No tasks yet",
  },
  notes: {
    icon: StickyNote,
    message: "No notes yet",
  },
  leads: {
    icon: ClipboardList,
    message: "No leads found",
  },
  info: {
    icon: Info,
    message: "No additional information",
  },
};

const EmptyState: React.FC<EmptyStateProps> = ({ type, actionLabel, onAction }) => {
  const { icon: Icon, message } = config[type];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 20px",
        textAlign: "center",
        minHeight: "200px",
      }}
    >
      <Icon
        size={48}
        strokeWidth={1.2}
        style={{ color: "#d1d5db", marginBottom: "12px" }}
      />
      <p
        style={{
          color: "#9ca3af",
          fontSize: "14px",
          fontFamily: '"Gilroy-Medium", "Gilroy", sans-serif',
          margin: "0 0 16px 0",
        }}
      >
        {message}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            fontSize: "13px",
            fontFamily: '"Gilroy-Medium", "Gilroy", sans-serif',
            fontWeight: 600,
            color: "#fff",
            backgroundColor: "#3faefd",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#2196f3";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#3faefd";
          }}
        >
          <Plus size={16} />
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
